import React from 'react';
import { connect } from 'react-redux';
import { ComponentProptypes, mapStateToProps } from './properties';
import CompetitorUrlContext from './Context';
import BaseComponent from './Components/BaseComponent';
import ModalHandler from './Components/ModalHandler';
import ErrorHandler from './Components/ErrorHandler';
import './CompetitorUrl.less';

export function CompetitorUrlComponent(props) {
    const {
        baseComponent,
        propertyPlayback,
        propertyNotFound,
        errors
    } = props;
    return (
        <CompetitorUrlContext>
            <ModalHandler
                propertyPlayback={propertyPlayback}
                propertyNotFound={propertyNotFound}
            />
            <BaseComponent
                {...baseComponent}
            />
            <ErrorHandler {...errors} />
        </CompetitorUrlContext>
    );
}

CompetitorUrlComponent.propTypes = ComponentProptypes;

export default connect(mapStateToProps)(CompetitorUrlComponent);
